var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddDriverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 2a.5.5 0 00-.5.5V9H7.5a.5.5 0 000 1H9v1.5a.5.5 0 001 0V10h1.5a.5.5 0 000-1H10V7.5a.5.5 0 00-.5-.5zM5.257 6A5.478 5.478 0 004 9.5a5.5 5.5 0 00.207 1.5H4.06C1.533 11 .098 10.157.005 8.455L0 8.274V7.5a1.5 1.5 0 011.356-1.493L1.5 6h3.757zM4 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm5 1a2 2 0 011.656 3.122 5.522 5.522 0 00-3.121.24A2 2 0 019 1z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDriverIcon);
export default __webpack_public_path__ + "static/media/add-driver-icon.5d68d46f7b57a072a65cf5cb4421b6f3.svg";
export { ForwardRef as ReactComponent };